import { useQuery } from 'react-query';
import { accountService } from 'services';
import { ServerStateKeysEnum } from '../../constants';

export const useIteroOrderDetails = (orderNumber: string) => {
  return useQuery(
    `${ServerStateKeysEnum.orderDetails}-${orderNumber}`,
    () => {
      return accountService.getITeroOrderDetails(orderNumber);
    },
    {
      staleTime: Infinity,
      enabled: orderNumber?.length > 0,
      refetchOnWindowFocus: false,
    }
  );
};
